import React, { useState } from "react";
import { toast } from "react-toastify";

export default function UrlCopyCell({
	url,
	display,
	error = false,
	mono = false,
	label = "Copy",
}) {
	const [copied, setCopied] = useState(false);
	const shown = display ?? url;

	async function handleCopy(event) {
		event.preventDefault();
		event.stopPropagation();
		try {
			await navigator.clipboard.writeText(url);
			setCopied(true);
			window.setTimeout(() => setCopied(false), 1500);
		} catch {
			toast.error(`Could not copy ${label.toLowerCase()}`);
		}
	}

	const spanClass = [
		"monitoring__ai-traffic-url-cell",
		error ? "monitoring__ai-traffic-url-cell--error" : "",
		mono ? "monitoring__ai-traffic-url-cell--mono" : "",
	]
		.filter(Boolean)
		.join(" ");

	return (
		<div className="monitoring__ai-traffic-url-copy-cell">
			<span className={spanClass} title={url}>
				{shown}
			</span>
			<button
				type="button"
				className="monitoring__ai-traffic-url-copy-btn"
				onClick={handleCopy}
				aria-label={label}
				title={label}
			>
				<i className={copied ? "fas fa-check" : "far fa-copy"} aria-hidden />
			</button>
		</div>
	);
}
